
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/flamingo",
      function () {
        return require("private-next-pages/cases/flamingo/index.tsx");
      }
    ]);
  